import { OcrResult } from "@finway-group/shared/lib/models"
import { roundNumberTo2Decimals } from "@finway-group/shared/lib/utils"
import { Col, Row } from "antd"
import React from "react"
import i18n from "~Shared/locales/i18n"
import { SectionHeader, TableHeader } from "./shared"

interface ItemsProps {
    data: OcrResult
}

export const EInvoiceItems = ({ data }: ItemsProps) => {
    if (!data.eInvoiceData?.invoiceLines) {
        return null
    }

    return (
        <>
            <SectionHeader title={i18n.t("label:itemized_charges")} />
            <TableHeader
                columns={[
                    { span: 2, label: i18n.t("label:position") },
                    { span: 7, label: i18n.t("label:description") },
                    { span: 4, label: i18n.t("label:net_price") },
                    { span: 3, label: i18n.t("label:qty") },
                    { span: 4, label: i18n.t("label:vat_rate") },
                    { span: 4, label: i18n.t("label:gross_price"), textAlign: "right" },
                ]}
            />
            <div className="border-1 border-gray-200 font-medium text-xs space-y-8 rounded-sm">
                {data.eInvoiceData.invoiceLines.map((invoiceLine: any, index: number) => (
                    <Row key={invoiceLine.lineId} className={`p-10 px-14 text-black ${index !== data.eInvoiceData!.invoiceLines.length - 1 ? "border-b-1 border-gray-200" : ""}`}>
                        <Col span={2} className="font-thin">
                            <span>{invoiceLine.lineId}</span>
                        </Col>
                        <Col span={6}>
                            <span>{invoiceLine.name}</span>
                        </Col>
                        <Col span={4} offset={1}>
                            <span>{roundNumberTo2Decimals(invoiceLine.itemPrice)}</span>
                        </Col>
                        <Col span={3}>
                            <span>{invoiceLine.invoicedQuantity}</span>
                        </Col>
                        <Col span={4}>
                            <span>{invoiceLine.taxCategoryPercent}%</span>
                        </Col>
                        <Col span={4} className="text-right">
                            <span>{roundNumberTo2Decimals(invoiceLine.lineExtensionAmount)}</span>
                        </Col>
                    </Row>
                ))}
            </div>
        </>
    )
}
